import SidebarLayout from '../../components/SidebarLayout';
import NoteReferralUpdateForm from '../../components/sections/MTSS/NoteReferralUpdateForm';
import { useParams } from 'react-router-dom';
import AccessWrapper from '../../components/AccessWrapper';
import AuthContext from '../../context/AuthContext';
import { useContext, useEffect } from 'react';

export default function NoteReferral() {
  const params = useParams();
  const id = params?.id;
  const { postPageView, user, baseUrl } = useContext(AuthContext);

  useEffect(() => {
    postPageView(baseUrl, user.name, user.role, 'form/update-note-referral');
  }, []);
  return (
    <AccessWrapper
      allowedGroups={[
        'teacher',
        'mtss_member',
        'mtss_supervisor',
        'mtss_admin',
        'district_admin',
      ]}
    >
      <div>
        <SidebarLayout
          propComponents={<NoteReferralUpdateForm params={id} />}
          heading={'Update Note / Referral'}
        />
      </div>
    </AccessWrapper>
  );
}
